import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { BaseRestApiService } from '@shared/services/base-rest-api.service';
import { RestApiWrapperService } from '@shared/services/rest-api-wrapper.service';
import { Observable } from 'rxjs';

@Injectable()
export class SubmitBidService extends BaseRestApiService  {
  projectGroups = environment.serverUri + `api/${environment.apiVersion}/project-groups`;

  constructor(_restApiWrapperService: RestApiWrapperService) {
    super(_restApiWrapperService);
  }

  submitBid(projectGroupId: string): Observable<any> {
    const url = `${this.projectGroups}/${projectGroupId}/publish-tender`;
    return this.post<any>(url, JSON.stringify({}));
  }

  resubmitBid(projectGroupId: string) {
    const url = `${this.projectGroups}/${projectGroupId}/re-publish-tender`;
    return this.put(url, JSON.stringify({}));
  }

  withdrawBid( projectGroupId: string) {
    const url = `${this.projectGroups}/${projectGroupId}/withdraw-tender-bid`;
    return this.delete(url);
  }
}
